// DO NOT EDIT THIS FILE. It should be automatically generated by running
// pnpm generate-product-schemas
import { format } from 'date-fns/format'
import { sub } from 'date-fns/sub'
import * as z from 'zod'

import * as constants from '@nxt-insurance/constants'

// This is the base schema that can be extended when using it in configs
export const BaseSchema_PetHealthV1GetsafeDe = z.object({
  chipped: z.boolean().optional(),
  neutered: z.boolean().optional(),
  pet_name: z.string().min(1).optional(),
  pet_type: z.enum(['cat', 'dog']),
  breed_type: z.enum(['crossbreed', 'pedigree']),
  pet_gender: z.enum(['female', 'male']).optional(),
  chip_number: z.string().optional(),
  tariff_line: z.enum(['comfort', 'premium']),
  tariff_type: z.enum(['surgery_coverage', 'full_coverage']),
  first_breed_name: z.string().min(1).optional(),
  previous_insurer: z.string().min(1).optional(),
  pet_date_of_birth: z
    .union([z.number(), z.string(), z.date()])
    .pipe(
      z.coerce
        .date()

        .max(sub(new Date(), { weeks: 8 }))
    )
    .transform((value) => {
      return format(value, constants.SERVER_DATE_FORMAT)
    })
    .optional(),
  second_breed_name: z.string().min(1).optional(),
  living_environment: z.enum(['indoor', 'outdoor']).optional(),
  deductible_percentage: z.coerce
    .string()
    .pipe(z.enum(['0', '10', '20']))
    .pipe(z.coerce.number()),
  shoulder_height_class: z.enum(['lt_45_cm', 'gte_45_cm']).optional(),
  pet_age_at_contract_start: z.preprocess((val) => {
    if (val === '' || val === undefined) {
      return undefined
    }
    return Number(val)
  }, z.number().int().lte(7)),
  cancelled_by_previous_insurer: z.coerce
    .string()
    .pipe(z.enum(['false']))
    .transform(() => false)
    .optional(),
  previous_insurance_in_last_5y: z.boolean().optional(),
  no_critical_diseas_or_disability_confirmation: z.coerce
    .string()
    .pipe(z.enum(['true']))
    .transform(() => true)
    .optional(),
  no_recent_surgery_or_treatment_recommendation_confirmation: z.coerce
    .string()
    .pipe(z.enum(['true']))
    .transform(() => true)
    .optional(),
})

const Schema_PetHealthV1GetsafeDe = BaseSchema_PetHealthV1GetsafeDe.superRefine((values, ctx) => {
  if (
    values['previous_insurance_in_last_5y'] !== undefined &&
    [true].includes(values['previous_insurance_in_last_5y'])
  ) {
    if (values['previous_insurer'] === undefined) {
      ctx.addIssue({
        code: z.ZodIssueCode.invalid_type,
        expected: 'string',
        received: 'undefined',
        message: 'Required',
        path: ['previous_insurer'],
      })
    }
  }
})
  .superRefine((values, ctx) => {
    if (values['pet_type'] !== undefined && ['cat'].includes(values['pet_type'])) {
      if (values['living_environment'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'string',
          received: 'undefined',
          message: 'Required',
          path: ['living_environment'],
        })
      }
    }
  })
  .superRefine((values, ctx) => {
    if (
      values['pet_type'] !== undefined &&
      ['dog'].includes(values['pet_type']) &&
      values['first_breed_name'] !== undefined &&
      ['unknown'].includes(values['first_breed_name']) &&
      values['second_breed_name'] !== undefined &&
      ['unknown'].includes(values['second_breed_name'])
    ) {
      if (values['shoulder_height_class'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'string',
          received: 'undefined',
          message: 'Required',
          path: ['shoulder_height_class'],
        })
      }
    }
  })
  .superRefine((values, ctx) => {
    if (
      values['previous_insurance_in_last_5y'] !== undefined &&
      [true].includes(values['previous_insurance_in_last_5y'])
    ) {
      if (values['cancelled_by_previous_insurer'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'boolean',
          received: 'undefined',
          message: 'Required',
          path: ['cancelled_by_previous_insurer'],
        })
      }
    }
  })

export default Schema_PetHealthV1GetsafeDe
